import { NewsList as NewsListRoot } from './NewsList'

type NewsList = typeof NewsListRoot

const NewsList = NewsListRoot

export default NewsList
